import * as React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

export default function Step1({
  selectedCategory,
  setSelectedCategory,
  selectedSubCategory,
  setSelectedSubCategory,
  selectedSegments,
  setSelectedSegments,
  selectedTemplate,
  setSelectedTemplate,
  categories,
  subCategories,
  segments,
  templates,
  error,
}) {
  return (
    <Stack spacing={3}>
      <Typography
        variant="h5"
        gutterBottom
        component="div"
        sx={{ marginBottom: '10px' }}
      >
        Select A Template
      </Typography>

      <FormControl fullWidth>
        <Typography variant="subtitle1" gutterBottom component="div">
          Select Category<span style={{ color: 'red' }}>*</span>
        </Typography>

        <Select
          labelId="category-label"
          id="category-select"
          value={selectedCategory}
          label=""
          onChange={event => setSelectedCategory(event.target.value)}
        >
          {categories.map(item => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth disabled={!subCategories.length}>
        <Typography
          variant="subtitle1"
          gutterBottom
          component="div"
          sx={{ color: !subCategories.length ? 'grey' : '' }}
        >
          Select Sub-Category
        </Typography>
        <Select
          labelId="subcategory-label"
          id="subcategory-select"
          value={selectedSubCategory}
          label=""
          onChange={event => setSelectedSubCategory(event.target.value)}
        >
          {subCategories.map(item => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth disabled={!segments.length}>
        <Typography
          variant="subtitle1"
          gutterBottom
          component="div"
          sx={{ color: !segments.length ? 'grey' : '' }}
        >
          Select Segment
        </Typography>
        <Select
          labelId="segment-label"
          id="segment-select"
          value={selectedSegments}
          label=""
          onChange={event => setSelectedSegments(event.target.value)}
        >
          {segments.map(item => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
        fullWidth
        error={error.template}
        disabled={!templates.length}
      >
        <Typography
          variant="subtitle1"
          gutterBottom
          component="div"
          sx={{ color: !templates.length ? 'grey' : '' }}
        >
          Select Template<span style={{ color: 'red' }}>*</span>
        </Typography>
        <Select
          labelId="templates-label"
          id="templates-select"
          value={selectedTemplate}
          label=""
          onChange={event => setSelectedTemplate(event.target.value)}
        >
          {templates.map(item => (
            <MenuItem key={item._id} value={item}>
              {item.template_name}
            </MenuItem>
          ))}
        </Select>
        {error.template ? (
          <FormHelperText>Please select a template</FormHelperText>
        ) : null}
      </FormControl>
    </Stack>
  );
}
